import React from 'react';
import { FaUser } from 'react-icons/fa'; // FaCalendarAlt was unused, so I removed it

// Sample data for blog posts, using farming-related placeholders
const blogPosts = [
    {
        imageUrl: "https://m.media-amazon.com/images/I/517MtMdokrL.jpg",
        author: "Bereilly_VermiCompost",
        title: "How Drip Irrigation Can Be Useful for a Vermicompost Plant",
        link: "#post1"
    },
    {
        imageUrl: "https://creativefarmer.in/cdn/shop/products/vermi_435e263b-185e-4757-96ea-1f2cdb7b1727.jpg?v=1616320876",
        author: "organic_farming_expert",
        title: "Why Farmers Prefer Vermicompost in Organic Farming",
        link: "#post2"
    },
    {
        imageUrl: "https://casadeamor.in/cdn/shop/products/vermicompost-2.jpg?v=1625728097&width=1445",
        author: "green_gardener",
        title: "Why Vermicompost Organic Manure is a Must for Your Plants",
        link: "#post3"
    },
];

const VermiCompostProcess: React.FC = () => { // Renamed from FarmingBlogPosts
    return (
        // Added responsive padding (px-4 sm:px-6)
        <div className="py-16 px-4 sm:px-6 bg-gray-50"> 
            <div className="max-w-6xl mx-auto">
                
                {/* Section Header - Font sizes adjusted */}
                <div className="text-center mb-16">
                    <p className="text-base sm:text-lg text-[#4f6a39] font-semibold uppercase">Latest News and Expert Advice</p>
                    {/* Adjusted H2 for better mobile fit (text-3xl) */}
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 mt-2">Farming Insights for Better Yields</h2> 
                    <p className="text-gray-600 mt-4 max-w-3xl mx-auto text-sm sm:text-base">
                        Stay updated with our latest research, best practices, and success stories from the field of organic farming.
                    </p>
                </div>

                {/* Blog Posts Grid - Already good (1 column, then 2, then 3) */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {blogPosts.map((post, index) => (
                        <a 
                            key={index}
                            href={post.link} 
                            className="bg-white rounded-lg shadow-xl overflow-hidden block 
                                       transform transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
                        >
                            {/* Image Container - Height adjusted for smaller screens */}
                            <div className="relative h-56 sm:h-64 w-full"> 
                                <img 
                                    src={post.imageUrl} 
                                    alt={post.title} 
                                    className="w-full h-full object-cover" 
                                />
                            </div>

                            {/* Text Content */}
                            <div className="p-5">
                                {/* Author/Meta Info */}
                                <div className="flex items-center space-x-3 text-xs sm:text-sm text-gray-500 mb-3">
                                    <span className="text-yellow-600">|</span> 
                                    <FaUser className="text-yellow-600" />
                                    <span>{post.author}</span>
                                </div>
                                
                                {/* Title - Font size adjusted for smaller screens (text-lg) */}
                                <h3 className="text-lg sm:text-xl font-bold text-gray-800 leading-snug hover:text-[#4f6a39] transition-colors">
                                    {post.title}
                                </h3>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default VermiCompostProcess;